import {find} from '../helpers';

const element = find('[data-video-stream]');
const videoBg = find('[data-video-bg]');

if (element) {
    import('./index');
}

if (videoBg) {
    import('./hero');
}
